export default {
  edit: {
    visible: false,
  },
  video: null,
  imageList: null,
}
